import {mxEvent} from "../GraphEditor/mxGraphFactory";

export class DraggablePane {
    constructor(element, minHeight = 0, options = {}) {
        this.element = element;
        this.isDragging = false;
        this.dragStartY = 0;
        this.dragStartHeight = 0;
        this.minHeight = minHeight;
        this.maxHeight = options.maxHeight;
        this.onResize = options.onResize;
        this.onResizeEnd = options.onResizeEnd;
        this.onResizeStart = options.onResizeStart;
        this.previousUserSelect = null;
    }

    handleDragStart = e => {
        this.isDragging = true;
        this.dragStartY = mxEvent.getClientY(e);
        this.dragStartHeight = this.element.offsetHeight;
        this.previousUserSelect = document.body.style.userSelect;
        document.body.style.userSelect = "none";
        this.consume(e);
        if (this.onResizeStart) {
            this.onResizeStart(this.dragStartHeight, e);
        }
        mxEvent.addGestureListeners(document, null, this.handleDragMove, this.handleDragEnd);
    };

    handleDragMove = e => {
        if (!this.isDragging) {
            return;
        }

        const deltaY = mxEvent.getClientY(e) - this.dragStartY;
        const height = this.clampHeight(this.dragStartHeight + deltaY);
        this.element.style.height = height + 'px';
        this.consume(e);

        if (this.onResize) {
            this.onResize(height, e);
        }
    };

    handleDragEnd = e => {
        if (!this.isDragging) {
            return;
        }

        const height = this.element.offsetHeight;
        this.isDragging = false;
        document.body.style.userSelect = this.previousUserSelect || "";
        mxEvent.removeGestureListeners(document, null, this.handleDragMove, this.handleDragEnd);
        this.consume(e);

        if (this.onResizeEnd) {
            this.onResizeEnd(height, e);
        }
    };

    destroy = () => {
        if (this.isDragging) {
            this.isDragging = false;
            document.body.style.userSelect = this.previousUserSelect || "";
            mxEvent.removeGestureListeners(document, null, this.handleDragMove, this.handleDragEnd);
        }
    };

    clampHeight(height) {
        const maxHeight = typeof this.maxHeight === 'function' ? this.maxHeight() : this.maxHeight;
        let nextHeight = Math.max(this.minHeight, height);

        if (maxHeight != null) {
            nextHeight = Math.min(maxHeight, nextHeight);
        }

        return nextHeight;
    }

    consume(e) {
        if (e != null) {
            mxEvent.consume(e);
        }
    }
}
